"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingOperationStatusEnum = void 0;
var BillingOperationStatusEnum;
(function (BillingOperationStatusEnum) {
  /** Сервисное значение */
  BillingOperationStatusEnum[BillingOperationStatusEnum["not_created"] = 0] = "not_created";
  /** ожидает */
  BillingOperationStatusEnum[BillingOperationStatusEnum["pending"] = 10] = "pending";
  /**
   * ожидает подтверждения
   *
   * @deprecated Возможно, не используется
   */
  BillingOperationStatusEnum[BillingOperationStatusEnum["under_confirmation"] = 15] = "under_confirmation";
  /** исполняется */
  BillingOperationStatusEnum[BillingOperationStatusEnum["processing"] = 20] = "processing";
  /** отменена */
  BillingOperationStatusEnum[BillingOperationStatusEnum["canceled"] = 40] = "canceled";
  /** завершилась с ошибкой */
  BillingOperationStatusEnum[BillingOperationStatusEnum["failed"] = 50] = "failed";
  /** завершена успешно */
  BillingOperationStatusEnum[BillingOperationStatusEnum["succeed"] = 100] = "succeed";
})(BillingOperationStatusEnum = exports.BillingOperationStatusEnum || (exports.BillingOperationStatusEnum = {}));
